export default __webpack_public_path__ + "static/media/happyWoman.587f962b.png";